import React from 'react'
import './Footer.css';



function Footer() {
  return (
    <footer id='footer'>
     <div>Copyright &copy; 2023 Adventour. All rights reserved <br/>
     Conact us @ trenatto82@gmailcom, odhisayim@gmail.com or +254728174549, +254111770495. </div>
    </footer>
  )
}

export default Footer;